import React, { useState, useContext } from "react";
import { Modal, Input, message } from "antd";
import Template from "../assests/ViewBirthday.png";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import UserAvatar from "../assests/user_avatar.png";

const { TextArea } = Input;

export default function ViewBirthDay({ employee }) {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [wishText, setWishText] = useState("");
    const [imgErr, setImgErr] = useState(false);

    const { backUrl, authData } = useContext(AuthContext);

    // Full Name Resolution: Displays both first_name & last_name
    const employeeName = (() => {
        const fn = employee?.user?.first_name || employee?.first_name || "";
        const ln = employee?.user?.last_name || employee?.last_name || "";
        const combined = `${fn} ${ln}`.trim();
        if (combined) return combined;
        return employee?.full_name || employee?.employee_name || employee?.name || "Employee";
    })();

    const organizationName =
        employee?.organisation_name ||
        employee?.organisation?.name ||
        "Baashyaam Group";

    const departmentName =
        employee?.department_name ||
        employee?.department?.name ||
        employee?.department ||
        "Department";

    const designation =
        employee?.designation_name ||
        employee?.designation?.name ||
        employee?.designation ||
        "Team Member";

    const rawPhoto = employee?.photo || employee?.profile_photo || employee?.user?.photo;
    const photoSrc = !imgErr && rawPhoto ? rawPhoto : UserAvatar;

    const [isSending, setIsSending] = useState(false);

    const showModal = () => setIsModalVisible(true);
    const handleCancel = () => {
        if (!isSending) {
            setIsModalVisible(false);
        }
    };

    const handleSendWish = async () => {
        if (!wishText.trim()) {
            message.warning("Please enter your wish before sending 🎂");
            return;
        }

        setIsSending(true);
        try {
            await axios.post(
                `${backUrl}/api/probation/celebrations/send/`,
                {
                    receiver_id: employee?.id,
                    occasion: "BIRTHDAY",
                    message: wishText,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );

            message.success("🎉 Your wish has been sent successfully!");
            setWishText("");
            setIsModalVisible(false);
        } catch (error) {
            console.error("Error sending wish:", error);
            message.error("Failed to send your wish. Please try again.");
        } finally {
            setIsSending(false);
        }
    };

    return (
        <>
            <style>{`
                .birthday-card-container {
                    position: relative;
                    width: 430px;
                    height: 230px;
                    overflow: hidden;
                    margin: 0 auto;
                    border-radius: 14px;
                    box-shadow: 0 8px 24px rgba(0,0,0,0.18), 0 2px 6px rgba(0,0,0,0.06);
                    font-family: 'Poppins', sans-serif;
                    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .birthday-card-container:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 14px 32px rgba(0,0,0,0.25);
                }

                .birthday-card-bg {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0.95;
                }

                .birthday-card-photo {
                    position: absolute;
                    top: 48px;
                    left: 48px;
                    width: 118px;
                    height: 122px;
                    object-fit: cover;
                    border-radius: 10px;
                    box-shadow: 0 6px 16px rgba(0,0,0,0.3);
                    border: 2px solid #ffffff;
                }

                .birthday-card-details {
                    position: absolute;
                    top: 52px;
                    left: 212px;
                    right: 15px;
                    color: #3b2b2b;
                    text-align: left;
                    line-height: 1.3;
                }

                .birthday-card-name {
                    margin: 0 0 6px 0;
                    font-size: 14px;
                    font-weight: 800;
                    color: #9b4d4d;
                    text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
                    word-break: break-word;
                    line-height: 1.25;
                }

                .birthday-card-info {
                    margin: 3px 0;
                    font-size: 11px;
                    font-weight: 600;
                    color: #5a3939;
                    word-break: break-word;
                }

                .birthday-card-button {
                    margin-top: 10px;
                    padding: 7px 20px;
                    background: linear-gradient(135deg, #ff7f7f 0%, #ff5252 100%);
                    color: #ffffff;
                    border: none;
                    border-radius: 22px;
                    font-size: 11px;
                    font-weight: 800;
                    cursor: pointer;
                    box-shadow: 0 4px 12px rgba(255, 82, 82, 0.38);
                    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                }

                .birthday-card-button:hover {
                    transform: scale(1.04) translateY(-1px);
                    box-shadow: 0 6px 18px rgba(255, 82, 82, 0.5);
                }

                @media (max-width: 480px) {
                    .birthday-card-container {
                        width: 95vw;
                        max-width: 380px;
                        height: auto;
                        aspect-ratio: 430/230;
                    }

                    .birthday-card-photo {
                        top: 21%;
                        left: 11.2%;
                        width: 27.5%;
                        height: 53%;
                    }

                    .birthday-card-details {
                        top: 22%;
                        left: 49%;
                        right: 5%;
                    }

                    .birthday-card-name {
                        font-size: clamp(12px, 3.2vw, 14px);
                        margin: 0 0 5px 0;
                    }

                    .birthday-card-info {
                        font-size: clamp(9px, 2.6vw, 11px);
                        margin: 2px 0;
                    }

                    .birthday-card-button {
                        margin-top: 8px;
                        padding: 5px 14px;
                        font-size: clamp(9px, 2.5vw, 11px);
                    }
                }
            `}</style>

            <div className="birthday-card-container">
                {/* 🎨 Background template */}
                <img
                    src={Template}
                    alt="Birthday Template"
                    className="birthday-card-bg"
                />

                {/* 🖼️ Employee photo */}
                <img
                    src={photoSrc}
                    onError={() => setImgErr(true)}
                    alt={employeeName}
                    className="birthday-card-photo"
                />

                {/* ✨ Text details */}
                <div className="birthday-card-details">
                    <h2 className="birthday-card-name">
                        {employeeName}! 🎉
                    </h2>
                    <p className="birthday-card-info">
                        {designation}
                    </p>
                    <p className="birthday-card-info">
                        {departmentName} Department
                    </p>
                    <p className="birthday-card-info" style={{ fontWeight: 800, color: "#9b4d4d" }}>
                        {organizationName}
                    </p>

                    {/* 🎁 Send Wishes Button */}
                    <button
                        onClick={showModal}
                        className="birthday-card-button"
                    >
                        <span>Send Wishes</span>
                        <span>🎁</span>
                    </button>
                </div>

                {/* 💬 Modal for Sending Wishes */}
                <Modal
                    title={
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{ fontSize: 20 }}>🎂</span>
                            <span style={{ fontWeight: 800, fontSize: 16, color: "#0f172a" }}>
                                Send Wish to {employeeName}
                            </span>
                        </div>
                    }
                    open={isModalVisible}
                    onCancel={handleCancel}
                    onOk={handleSendWish}
                    okText="Send Wish 🎉"
                    cancelText="Cancel"
                    centered
                    confirmLoading={isSending}
                    okButtonProps={{
                        loading: isSending,
                        style: {
                            background: "linear-gradient(135deg, #ff7f7f 0%, #ff5252 100%)",
                            borderColor: "transparent",
                            color: "#fff",
                            fontWeight: 800,
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(255,82,82,0.35)",
                        },
                    }}
                >
                    <TextArea
                        rows={4}
                        placeholder="Type your heartfelt birthday wishes here..."
                        value={wishText}
                        onChange={(e) => setWishText(e.target.value)}
                        style={{
                            borderRadius: "10px",
                            resize: "none",
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: "13px",
                            border: "1.5px solid #cbd5e1",
                            marginTop: "10px",
                        }}
                    />
                </Modal>
            </div>
        </>
    );
}